import { render } from "./UnitZeroOverviewTable.vue?vue&type=template&id=71dfcb78&scoped=true"
import script from "./UnitZeroOverviewTable.vue?vue&type=script&lang=js"
export * from "./UnitZeroOverviewTable.vue?vue&type=script&lang=js"

import "./UnitZeroOverviewTable.vue?vue&type=style&index=0&id=71dfcb78&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dfcb78"]])

export default __exports__